import React from 'react'

export const NoDataUI = <span style={{ color: 'silver' }}>No data</span>
